/******************************************************************************
 * FILE: src/modules/wms/work/services/wmsWorkService.js
 * MODULE: Work Management System (WMS)
 * FEATURE: Work Management API Service
 *
 * PURPOSE:
 * Frontend API client for Work Management
 *
 * BACKEND:
 * /api/wms/works
 *****************************************************************************/

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * LIST WORKS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/works
 */
 async function listWorks(params = {}) {

  const res = await axiosClient.get(
    "/api/wms/works",
    { params }
  );

  const payload = res.data?.data || {};

  return {
    items: payload.data || [],
    pagination: payload.pagination || {},
  };
}

/**
 * ----------------------------------------------------------------------
 * GET WORK
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/works/:id
 */
async function getWork(workId) {

  const res = await axiosClient.get(
    `/api/wms/works/${workId}`
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE WORK
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/works
 */
async function createWork(payload) {

  const res = await axiosClient.post(
    "/api/wms/works",
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE WORK
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/wms/works/:id
 */
async function updateWork(
  workId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/works/${workId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * DELETE WORK
 * ----------------------------------------------------------------------
 * Backend:
 * DELETE /api/wms/works/:id
 */
async function deleteWork(workId) {

  const res = await axiosClient.delete(
    `/api/wms/works/${workId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE ADHOC WORK
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/works/create-adhoc
 */
async function createAdhocWork(payload) {

  const res = await axiosClient.post(
    "/api/wms/works/create-adhoc",
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE WORK FROM TEMPLATE
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/works/create-from-template
 */
async function createWorkFromTemplate(payload) {

  const res = await axiosClient.post(
    "/api/wms/works/create-from-template",
    payload
  );

  return res.data.data;
}



/**
 * ----------------------------------------------------------------------
 * GET ASSIGNMENTS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/works/:id/assignments
 */
async function getAssignments(workId) {

  const res = await axiosClient.get(
    `/api/wms/works/${workId}/assignments`
  );

  return res.data.data || [];
}

async function getWorkChecklists(workId) {

  const res = await axiosClient.get(
    `/api/wms/works/${workId}/checklists`
  );

  return res.data.data || [];
}
/**
 * ----------------------------------------------------------------------
 * ADD ASSIGNMENTS
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/works/:id/assignments
 */
async function addAssignments(
  workId,
  assignments
) {

  const res = await axiosClient.post(
    `/api/wms/works/${workId}/assignments`,
    {
      assignments
    }
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * GET WATCHERS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/works/:id/watchers
 */
async function getWatchers(workId) {

  const res = await axiosClient.get(
    `/api/wms/works/${workId}/watchers`
  );

  return res.data.data || [];
}

/**
 * ----------------------------------------------------------------------
 * GET WORK ITEMS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/works/:id/items
 */
async function getWorkItems(workId) {

  const res = await axiosClient.get(
    `/api/wms/works/${workId}/items`
  );

  return res.data.data || [];
}

/**
 * ----------------------------------------------------------------------
 * GET WORK ITEM CHECKLISTS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/works/work-items/:id/checklists
 */
async function getWorkItemChecklists(workItemId) {

  const res = await axiosClient.get(
    `/api/wms/works/work-items/${workItemId}/checklists`
  );

  return res.data.data || [];
}

async function getWorkChecklistItems(workChecklistId) {

    const res = await axiosClient.get(

        `/api/wms/works/work-checklists/${workChecklistId}/items`

    );

    return res.data.data || [];
}

/******************************************************************************
 * SAVE CHECKLIST RESPONSE
 ******************************************************************************/

async function saveChecklistResponse(
    workChecklistItemId,
    payload
) {

    const res = await axiosClient.post(
        `/api/wms/works/checklist-items/${workChecklistItemId}/response`,
        payload
    );

    return res.data.data;

}
/**
 * ----------------------------------------------------------------------
 * ADD WATCHERS
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/works/:id/watchers
 */
async function addWatchers(
  workId,
  watcherIds
) {

  const res = await axiosClient.post(
    `/api/wms/works/${workId}/watchers`,
    {
      watcher_ids: watcherIds
    }
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * ADD COMMENT
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/works/:id/comments
 */
async function addComment(
  workId,
  payload
) {

  const res = await axiosClient.post(
    `/api/wms/works/${workId}/comments`,
    payload
  );

  return res.data.data;
}


/**
 * ----------------------------------------------------------------------
 * UPDATE STATUS
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/works/:id/status
 */
async function updateStatus(
  workId,
  payload
) {

  const res = await axiosClient.post(
    `/api/wms/works/${workId}/status`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */
const wmsWorkService = {

  listWorks,
  getWork,

  createWork,
  updateWork,
  deleteWork,

  createAdhocWork,
  createWorkFromTemplate,

  getAssignments,
  addAssignments,

  getWatchers,
  addWatchers,

  addComment,
  updateStatus,
  getWorkItems,
  getWorkItemChecklists,
  getWorkChecklistItems,
  saveChecklistResponse,
  getWorkChecklists,
  updateWork,
};

export default wmsWorkService;